import { Model } from 'modules/core/lib/mobx-rest'

export interface IStatus {
  [key: string]: any
}

class Status extends Model<IStatus> {}

export default Status
